// SEE-1730: import status subscriptions on the CDK API (speedchain-cdk graphql/12-live-updates.graphql).
// The server admits only a member of the requested company, for the company selected in their
// session, and delivers only rows whose paidolId and authPaidolId both match.

import {
  FlexCodeImport,
  FlexFieldUpload,
  HighnoteTransactionEventPostingUpdate,
  JobCodeImport,
  TransactionsDownloadQueue,
  TransactionsReceiptsDownloadQueue,
} from 'CDK_API';

export type OnUpdateJobCodeImportByPaidolId = { onUpdateJobCodeImportByPaidolId?: JobCodeImport | null };
export type OnUpdateFlexCodeImportByPaidolId = { onUpdateFlexCodeImportByPaidolId?: FlexCodeImport | null };
export type OnUpdateFlexFieldUploadByPaidolId = {
  onUpdateFlexFieldUploadByPaidolId?: FlexFieldUpload | null;
};

export const onUpdateJobCodeImportByPaidolId = /* GraphQL */ `
  subscription OnUpdateJobCodeImportByPaidolId($paidolId: ID!) {
    onUpdateJobCodeImportByPaidolId(paidolId: $paidolId) {
      id
      paidolId
      authPaidolId
      storageFileKey
      fileName
      status
      errors
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateFlexCodeImportByPaidolId = /* GraphQL */ `
  subscription OnUpdateFlexCodeImportByPaidolId($paidolId: ID!) {
    onUpdateFlexCodeImportByPaidolId(paidolId: $paidolId) {
      id
      paidolId
      authPaidolId
      type
      storageFileKey
      fileName
      status
      errors
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateFlexFieldUploadByPaidolId = /* GraphQL */ `
  subscription OnUpdateFlexFieldUploadByPaidolId($paidolId: ID!) {
    onUpdateFlexFieldUploadByPaidolId(paidolId: $paidolId) {
      id
      paidolId
      authPaidolId
      flexFieldId
      storageFileKey
      fileName
      status
      errors
      rowCount
      createdBy
      createdAt
      updatedAt
    }
  }
`;

// SEE-1235: the two export queues and ERP posting status, row-scoped: each subscription takes the
// row id as well as the selected company. The server delivers an export update only to the user
// who requested it.
export type OnUpdateTransactionsDownloadQueueById = {
  onUpdateTransactionsDownloadQueueById?: TransactionsDownloadQueue | null;
};
export type OnUpdateTransactionsReceiptsDownloadQueueById = {
  onUpdateTransactionsReceiptsDownloadQueueById?: TransactionsReceiptsDownloadQueue | null;
};
export type OnUpdateHighnoteTransactionEventById = {
  onUpdateHighnoteTransactionEventById?: HighnoteTransactionEventPostingUpdate | null;
};

export const onUpdateTransactionsDownloadQueueById = /* GraphQL */ `
  subscription OnUpdateTransactionsDownloadQueueById($id: ID!, $paidolId: ID!) {
    onUpdateTransactionsDownloadQueueById(id: $id, paidolId: $paidolId) {
      id
      user_id
      paidol_id
      range_option
      start_date
      end_date
      columns
      s3_key
      cron_status
      mark_as_exported
      exported_count
      skipped_count
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateTransactionsReceiptsDownloadQueueById = /* GraphQL */ `
  subscription OnUpdateTransactionsReceiptsDownloadQueueById($id: ID!, $paidolId: ID!) {
    onUpdateTransactionsReceiptsDownloadQueueById(id: $id, paidolId: $paidolId) {
      id
      user_id
      paidol_id
      paidolUserId
      s3_key
      cron_status
      error_code
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateHighnoteTransactionEventById = /* GraphQL */ `
  subscription OnUpdateHighnoteTransactionEventById($id: ID!, $paidolId: ID!) {
    onUpdateHighnoteTransactionEventById(id: $id, paidolId: $paidolId) {
      id
      paidolId
      authPaidolId
      erpPostingStatus
      erpPostingError
      erpApprovalStatus
      agaveExpenseId
    }
  }
`;
